import { Form, FormProps } from "antd";
import { INITIAL_SEARCH_FORM_VALUES, SearchFormInputs} from "../../../constants";
import { useNavigate } from "react-router-dom";
import { FC, ReactNode, useState } from "react";
import { prepareSearchObject } from "../utils"
import { simpleHash } from "src/utility/security";
import { explode } from "src/utility/objects";
import { track } from "@amplitude/analytics-browser";


export const SearchForm: FC<{ render: (props: { values: { journeyType?: number }; errorFields: string[] }) => ReactNode, onFinish?:(values:SearchFormInputs)=>void; initialValues?:SearchFormInputs } & FormProps> = ({ render, initialValues = INITIAL_SEARCH_FORM_VALUES, onFinish, onFinishFailed, ...props }) => {
  const correctedInitialValues = prepareSearchObject(initialValues);
  const [form] = Form.useForm();
  const journeyType = Form.useWatch("journeyType", form);
  const [errorFields, setErrorFields] = useState<string[]>([]);
  const navigate = useNavigate();
  const handleSubmit = (values: SearchFormInputs) => {
    const completeValues = explode(values, INITIAL_SEARCH_FORM_VALUES);
    const searchString = JSON.stringify(completeValues);
    const {hash} = simpleHash(searchString);
    localStorage.setItem(hash, searchString);
    navigate(`/travel/tickets/${hash}?t=${Date.now()}`);
    onFinish?.(completeValues);
    track("Search Submitted",{
      values: completeValues
    })
  };

  const handleFail = async () => {
    try {
      await form.validateFields();
      setErrorFields([]);
    } catch (errorInfo:any) {
      const actualErrors = errorInfo.errorFields.map((f: any) => f.name[0]);
      setErrorFields(actualErrors);
      onFinishFailed?.(errorInfo);
    }
  };
   const handleChangeValues = async ()=>{
    try {
      await form.validateFields({validateOnly:true});
      setErrorFields([]);
    } catch (errorInfo: any) {
      const values = form.getFieldsValue();
      const nonRequiredErrors = errorInfo.errorFields
        .filter((f: any) => {
          const value = values[f.name[0]];
          return value !== undefined && value !== null && value !== '';
        })
        .map((f: any) => f.name[0]);
      setErrorFields(nonRequiredErrors);
    }
  }

  return (
    <Form
      form={form}
      onFinish={handleSubmit}
      onFinishFailed={handleFail}
      onValuesChange={handleChangeValues}
      initialValues={correctedInitialValues}
      className="w-full"
      {...props}
    >
      {render({ values: { journeyType }, errorFields })}
    </Form>
  );
};



